export const CORPORATE_FRESHOLD = 1000000
export const TURNOVER_MID_FRESHOLD = 50000
export const AFFILIATE_TURNOVER_FRESHOLD = 75000
export const AFFILIATE_MONTHS_TRADING_LIMITED_FRESHOLD = 12
export const AFFILIATE_YEARS_TRADING_SOLE_FRESHOLD = 1
